/**
 * Logic for loading i18n/language/locale configuration from the backend.
 *
 * Important information: Imports seem to have unexpected behavior within this file.
 *  - Nuxt auto-import does not work in here, but aliases do
 *  - Async imports *may* lead to unexpected consequences (e.g. no errors and freeze after nitro middlewares)
 */
import { useDataCache } from '#nuxt-multi-cache/composables';
import ConfigurationApi from '@/api/hybris/ConfigurationApi';
import { useAxios } from '@/utils/axios/useAxios';

export default defineI18nLocale(async function loadTranslations(locale) {
  try {
    const config = useRuntimeConfig();
    const langCookie = unref(useCookie('i18n_redirected'));
    const isAppView = unref(useIsAppView());
    const { host, pathname } = useRequestURL();
    const { baseStore, isMultilang, language } = getBaseStoreData(host, pathname, config, langCookie);
    assertHasValues({ host, pathname, baseStore, language, baseStoreConfig });

    const api = new ConfigurationApi({
      client: useAxios(),
      ...config,
      baseStore,
      isAppView,
      useDataCache,
    });

    const { data } = await api.translations(isMultilang ? language : undefined);

    return data;
  } catch (error: any) {
    throw createError({
      statusCode: 500,
      statusMessage: `Failed to load translations (${locale}): ${error.toString()}`,
      cause: error,
    });
  }
});
